import { render, staticRenderFns } from "./ShipmentsManagementToolbar.vue?vue&type=template&id=2496d61c&scoped=true&"
import script from "./ShipmentsManagementToolbar.vue?vue&type=script&lang=ts&"
export * from "./ShipmentsManagementToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentsManagementToolbar.vue?vue&type=style&index=0&id=2496d61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2496d61c",
  null
  
)

export default component.exports